// Functional submissions only: no page tracking, no private credentials. Pending
// requests survive reloads in this tab and are removed as soon as SQS accepts them.
function courierSignupDelivery(config) {
  const storageKey = 'courier.pending-signups.v1';
  const maxAge = 24 * 60 * 60 * 1000;
  let queue = [], busy = false, timer;
  try {
    const stored = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) queue = stored.filter(row => row && typeof row.body === 'string' &&
      row.body.length < 16000 && Number.isFinite(row.created) && row.created > Date.now() - maxAge &&
      row.created <= Date.now() && Number.isFinite(row.next)).slice(0, 30);
  } catch (_) { /* Storage may be blocked; keep in-memory delivery available. */ }
  function persist() {
    try {
      if (queue.length) sessionStorage.setItem(storageKey, JSON.stringify(queue));
      else sessionStorage.removeItem(storageKey);
    } catch (_) { /* Network delivery continues when browser storage is unavailable. */ }
  }
  function notify(state, id) {
    window.dispatchEvent(new CustomEvent('courier:signup-delivery', {detail: {state, id, pending: queue.length}}));
  }
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(flush, Math.max(0, delay));
  }
  async function flush() {
    if (busy) return;
    const expired = queue.some(row => row.created <= Date.now() - maxAge);
    queue = queue.filter(row => row.created > Date.now() - maxAge);
    persist();
    if (expired) notify('expired');
    const row = queue.find(row => row.next <= Date.now());
    if (!row) {
      if (queue.length) schedule(Math.min(...queue.map(row => row.next)) - Date.now());
      return;
    }
    busy = true;
    let retryAfter = 0;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      // The endpoint comes from the current installation, never browser storage.
      const response = await fetch(config.endpoint, {method: 'POST', mode: 'cors', credentials: 'omit',
        headers: {'Content-Type': 'text/plain'}, body: row.body, keepalive: true, signal: controller.signal});
      if (!response.ok) {
        const value = response.headers?.get('Retry-After');
        retryAfter = /^\d+$/.test(value || '') ? Number(value) * 1000 : Math.max(0, Date.parse(value) - Date.now()) || 0;
        throw new Error('intake unavailable');
      }
      queue = queue.filter(item => item !== row);
      notify('accepted', JSON.parse(row.body).id); // Durable intake accepted; does not imply email sending.
    } catch (_) {
      row.attempt = Math.min((row.attempt || 0) + 1, 8);
      row.next = Date.now() + Math.min(maxAge, Math.max(retryAfter, Math.min(60000, 1000 * 2 ** (row.attempt - 1))));
      notify('retrying', JSON.parse(row.body).id);
    } finally {
      clearTimeout(timeout);
      busy = false;
      persist();
      if (queue.length) schedule(Math.min(...queue.map(item => item.next)) - Date.now());
    }
  }
  window.addEventListener('online', () => { if (queue.length) schedule(0); });
  persist();
  if (queue.length) schedule(0);
  return payload => {
    const body = JSON.stringify({...payload, token: config.token});
    if (new TextEncoder().encode(body).length > 16000 || queue.length >= 30) {
      notify('capacity');
      console.warn('Courier: signup queue is full; retry when your connection recovers');
      return false;
    }
    queue.push({body, created: Date.now(), next: Date.now(), attempt: 0});
    persist();
    flush();
    return true;
  };
}

// Native forms are dormant until the server transfers website_forms ownership.
// Theme integration: include once, retain existing .klaviyo-form-* placeholders,
// and remove the Klaviyo onsite renderer at the reviewed storefront cutover.
// Preview before the cutover: add ?courier_forms_preview=1 to a page URL (embedded forms), or
// ?courier_forms_preview=<form id> (that popup). A preview saves nothing.
(() => {
  if (window.__courierNativeFormsInstalled) return;
  window.__courierNativeFormsInstalled = true;
  const config = {"endpoint": "https://ag.production.realm.sensibo.com/courier/pixel", "token": "cmQ7mofD44Cgot456GlIJ9LRUbRUkmM8", "configuration_url": "https://new-home.sensibo.com/courier-public/forms/"};
  const send = courierSignupDelivery(config), pending = new Map();
  // A form's own text can end without a full stop; the next sentence follows it.
  const sentence = text => /[.!?]$/.test(text.trim()) ? text.trim() : text.trim() + '.';
  // The visitor's country that the store detects from the address of the visitor (as the provider's forms gave each
  // sign-up a location). The automations of a list can read the country; without it a sign-up has none.
  let countryRequest = null;
  const visitorCountry = () => countryRequest = countryRequest || Promise.race([
    fetch('/browsing_context_suggestions.json', {credentials: 'same-origin'}).then(r => r.ok ? r.json() : null)
      .then(j => j?.detected_values?.country?.handle ? {code: j.detected_values.country.handle, name: j.detected_values.country.name} : null),
    new Promise(resolve => setTimeout(() => resolve(null), 1500))]).catch(() => null);
  const preview = new URL(location.href).searchParams.get('courier_forms_preview') || '';
  const trackingAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true &&
    window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  function rememberVisitor() {
    const url=new URL(location.href), token=url.searchParams.get('courier_visitor');
    if(token && token.length<1500 && trackingAllowed()) {
      try {localStorage.setItem('courier.visitor.v1',token);} catch (_) {}
      url.searchParams.delete('courier_visitor');history.replaceState(history.state,'',url.href);
    }
    if(!trackingAllowed())try{localStorage.removeItem('courier.visitor.v1');}catch(_){}
  }
  rememberVisitor();document.addEventListener('visitorConsentCollected',rememberVisitor);
  function saved(key) { try {return JSON.parse(localStorage.getItem('courier.form.' + key) || '{}');} catch (_) {return {};} }
  function remember(key, value) {if (trackingAllowed()) try {localStorage.setItem('courier.form.' + key, JSON.stringify(value));} catch (_) {}}
  function element(tag, text, attrs = {}) {
    const node = document.createElement(tag); if (text) node.textContent = text;
    Object.entries(attrs).forEach(([k,v]) => node.setAttribute(k, v)); return node;
  }
  function eligible(id, rules) {
    const previous = saved(id);
    if (rules.SUPPRESS_SUCCESS_FORM && previous.submitted) return false;
    if (rules.COOKIE_TIMEOUT && previous.dismissed > Date.now() - rules.COOKIE_TIMEOUT * 86400000) return false;
    if (rules.EXISTING_USER && (saved('known').subscribed || window.CourierCustomer?.subscribed === true)) return false;
    const countries = rules.GEO_IP?.whitelist;
    // Shopify's storefront localization is supplied by the theme, never inferred
    // from browser language. Unknown locations do not see a country-only offer.
    const country = document.documentElement.dataset.courierCountry || window.Shopify?.country;
    if (countries && !countries.includes(country)) return false;
    const paths = rules.URL_PATH_PATTERNS?.whitelist;
    if (paths && !paths.some(p => new RegExp('^' + p.split('*').map(v => v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('.*') + '$').test(location.pathname))) return false;
    return true;
  }
  function mount(id, definition, container, popup = false) {
    if (container.dataset.courierMounted) return;
    container.dataset.courierMounted = 'true';
    // Inline display: the theme hides an empty div (div:empty), and the host of a shadow root has no children of its own.
    const host = element('div'); host.style.display = 'block'; container.replaceChildren(host);
    const root = host.attachShadow({mode:'open'});
    const style = element('style');
    // A popup is a white card. An embedded form takes the colors and the font of the place where the theme puts it
    // (for example the dark footer), with the email field and the button in one row, as the Klaviyo forms were.
    style.textContent = `:host{display:block;color:${popup ? '#173f45' : 'inherit'};font:${popup ? '16px/1.5 Arial,sans-serif' : 'inherit'}}*{box-sizing:border-box}[hidden]{display:none!important}`
      + `section{position:relative;background:${popup ? '#fff' : 'transparent'};padding:${popup ? '20px' : '0'};border-radius:14px}h2{font-size:${popup ? '26px' : '1.15em'};line-height:1.2;margin:0 0 6px;font-weight:700}`
      + `p{margin:0 0 12px;opacity:.9}form{display:flex;flex-wrap:wrap;gap:8px;align-items:flex-end}label{display:grid;gap:4px;font-size:14px;flex:1 1 140px}`
      + `.inline label span{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)}input{font:inherit;font-size:15px;width:100%;padding:11px 14px;border:1px solid #9aaeb2;border-radius:24px;color:#173f45;background:#fff}`
      + `button,a{font:inherit;cursor:pointer}button{padding:11px 20px;font-weight:700;color:${popup ? '#fff' : '#173f45'};background:${popup ? '#087d6b' : '#fff'};border:0;border-radius:24px}`
      + `button:disabled{opacity:.6;cursor:wait}.close{position:absolute;right:10px;top:6px;padding:4px 10px;color:#173f45;background:transparent;font-size:26px;font-weight:400}`
      + `.status{margin:10px 0 0;font-size:14px}.trap{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}a{display:inline-block;margin:8px 12px 0 0;color:#087d6b}`;
    root.append(style); const section = element('section'); root.append(section);
    if (popup) {
      const close = element('button','×',{type:'button','aria-label':'Close'});
      close.className='close'; close.addEventListener('click',() => {remember(id,{...saved(id),dismissed:Date.now()});container.close();});section.append(close);
    }
    // hide_text: the theme writes the heading next to this place itself (the footer).
    const paragraphs = popup || !definition.display?.hide_text ? definition.disclosure || definition.text || [] : [];
    paragraphs.forEach((text,i) => section.append(element(i===0 ? 'h2':'p',text)));
    if (definition.links) {
      definition.links.forEach(link => {if (link.url.startsWith('https://')) section.append(element('a',link.text,{href:link.url}));});return;
    }
    const form=element('form'); const status=element('p','',{role:'status','aria-live':'polite'});status.className='status';
    if (definition.fields.length===1) form.className='inline';   // one email field: the label is for screen readers, the field shows "Email"
    for (const field of definition.fields) {
      const label=element('label'); label.append(element('span',field.label || (field.key==='$email'?'Email':field.key)));
      const input=element('input','',{name:field.key,type:field.type==='EMAIL'?'email':field.type==='PHONE_NUMBER'?'tel':'text',maxlength:'2000',
        placeholder:field.label || (field.key==='$email'?'Email':'')});
      input.required=field.required; if (field.type==='EMAIL') input.autocomplete='email'; label.append(input);form.append(label);
    }
    // Against automatic submissions (the Klaviyo forms had reCAPTCHA): a field that people do not see and do not fill,
    // and the time from the display of the form to the submission. The server checks both again.
    const trap=element('input','',{name:'website',tabindex:'-1',autocomplete:'off','aria-hidden':'true'});trap.className='trap';form.append(trap);
    const shown=Date.now();
    const button=element('button',definition.button,{type:'submit'});form.append(button);section.append(form,status);
    form.addEventListener('focusin', () => visitorCountry(), {once: true});
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (!form.reportValidity() || button.disabled) return;
      const fields={}; definition.fields.forEach(field => {const v=form.elements.namedItem(field.key).value.trim();if(v)fields[field.key]=v;});
      const request={event:'form_subscription',id:crypto.randomUUID(),form_id:id,trigger:'courier_submit',fields,
        definition_version:definition.version,company_id:definition.company_id,timestamp:new Date().toISOString(),
        check:{website:trap.value,elapsed_ms:Date.now()-shown}};
      if (preview) {form.hidden=true;status.textContent=sentence(definition.success || 'Thank you.')+' (Preview: nothing was saved.)';return;}
      pending.set(request.id,{button,status,form,id,definition}); button.disabled=true;status.textContent='Sending your request…';
      const country=await visitorCountry(); if (country) request.country=country;
      request.languages=(navigator.languages?.length ? [...navigator.languages] : [navigator.language||'']).slice(0,10).map(l=>String(l).slice(0,20));   // the browser's languages
      // With tracking consent: a key that stays in this browser, so the pixel can say that this browsing belongs to this sign-up.
      if (trackingAllowed()) {
        try {
          let key=localStorage.getItem('courier.visitor.key.v1');
          if (!key || !/^[A-Za-z0-9_-]{22,64}$/.test(key)) {key=crypto.randomUUID().replaceAll('-','');localStorage.setItem('courier.visitor.key.v1',key);}
          request.visitor_key=key;request.tracking_consent=true;
        } catch (_) { /* storage is blocked: the sign-up works without it */ }
      }
      if (!send(request)) {pending.delete(request.id);button.disabled=false;status.textContent='Your request could not be saved. Please try again.';}
    });
  }
  window.addEventListener('courier:signup-delivery', event => {
    const row=pending.get(event.detail.id); if(!row)return;
    if(event.detail.state==='accepted'){
      row.form.hidden=true;row.status.textContent=sentence(row.definition.success || 'Thank you. Your request has been received.')+' If confirmation is needed, please check your email.';
      remember(row.id,{submitted:true});if(row.definition.purpose==='email_subscription')remember('known',{subscribed:true});pending.delete(event.detail.id);
    }else if(event.detail.state==='retrying')row.status.textContent='Waiting for your connection. We’ll keep retrying; keep this page open.';
  });
  async function start() {
    const response=await fetch(config.configuration_url,{credentials:'omit',cache:'no-store'});
    if(!response.ok)return; const result=await response.json(); if(!result.enabled && !preview)return;
    const definitions={...result.configuration.forms,...result.configuration.promotions};
    const started=Date.now();
    function embeds(){for(const [id,definition] of Object.entries(definitions)){
      const display=definition.display;if(display?.kind!=='embed')continue;
      document.querySelectorAll('[data-courier-form="'+id+'"],'+display.selector).forEach(container=>mount(id,definition,container));
    }}
    embeds();const observer=new MutationObserver(embeds);observer.observe(document.body,{subtree:true,childList:true});
    // PageFly owns its existing markup. Capture this exact control before the
    // retired Klaviyo handler, keeping unrelated checkout/forms untouched.
    document.addEventListener('click',event=>{
      const button=event.target.closest?.('.__pf_7mXUSvV- .join-button');if(!button)return;
      const field=button.closest('.__pf_7mXUSvV-')?.querySelector('input#email[type=email]');if(!field?.reportValidity())return;
      event.preventDefault();event.stopImmediatePropagation();
      if(button.disabled)return;
      const d=definitions['pagefly-ai-assistant-waitlist'],id=crypto.randomUUID();
      const status=element('p','Sending your request…',{role:'status'});button.after(status);button.disabled=true;
      pending.set(id,{button,status,form:button,id:'pagefly-ai-assistant-waitlist',definition:d});
      if(preview){status.textContent='Preview: nothing was saved.';button.disabled=false;pending.delete(id);return;}
      if(!send({event:'form_subscription',id,form_id:'pagefly-ai-assistant-waitlist',trigger:'courier_submit',fields:{$email:field.value.trim()},
        company_id:d.company_id,definition_version:d.version,timestamp:new Date().toISOString(),check:{website:'',elapsed_ms:Date.now()-started}})){
        pending.delete(id);button.disabled=false;status.textContent='Your request could not be saved. Please try again.';
      }
    },true);
    let displayed=false;
    for(const [id,definition] of Object.entries(definitions)){
      if(definition.display?.kind!=='popup')continue;
      for(const rules of definition.display.rules){
        let shown=false;
        const show=()=>{
          if(shown||displayed||(!preview&&(!trackingAllowed()||!eligible(id,rules))))return;
          shown=true;displayed=true;const dialog=element('dialog','',{'aria-label':definition.name});
          dialog.style.cssText='border:0;border-radius:18px;padding:0;max-width:560px;width:calc(100% - 32px);box-shadow:0 16px 70px #0005';
          document.body.append(dialog);mount(id,definition,dialog,true);dialog.addEventListener('cancel',()=>remember(id,{...saved(id),dismissed:Date.now()}));dialog.showModal();
        };
        if(preview){if(preview===id)setTimeout(show,500);continue;}
        if(rules.DELAY)setTimeout(show,Math.max(0,rules.DELAY*1000-(Date.now()-started)));
        if(rules.EXIT_INTENT)document.addEventListener('mouseout',event=>{if(!event.relatedTarget&&event.clientY<=0)show();});
      }
    }
  }
  const run=()=>start().catch(()=>{/* Leave existing markup intact if configuration cannot be loaded. */});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
})();
